import { FormAtylBase } from '../../form-atyl-base'

export class AtylTextArea extends FormAtylBase<string> {
	controlType = 'textarea'
	type: string
    options: string[] = [];

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || ''
		this.options = options['options'] || []
	}
}
